import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  propertyGrid: {
    minWidth: 112,
    maxWidth: 112,
    width: 112,
    flexBasis: 112,
    flexShrink: 0,
    flexGrow: 0,
    paddingRight: 8
  },
  property: {
    fontFamily: "Segoe UI",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#1E1E1E"
  },
  value: {
    fontFamily: "Segoe UI",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#464646",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%"
  }
});

export default function PropertyRow({
  name,
  children
}: {
  name: string;
  children: React.ReactNode;
}) {
  const classes = useStyles();
  return (
    <Grid container item xs={12} wrap="nowrap">
      <Grid item className={classes.propertyGrid}>
        <Typography className={classes.property}>{name}</Typography>
      </Grid>
      <Grid item style={{ flex: 1, minWidth: 0 }}>
        <Typography component="div" className={classes.value}>
          {children}
        </Typography>
      </Grid>
    </Grid>
  );
}
